
import { LoadingIcon } from "@components/icons/loading";
import { viewportHeightWithoutMiniHeader } from "@modules";

export function FetchingWrapper({ isLoading, error, doesExist = true, mainWrapper, children }) {
    const heightClass = !mainWrapper ? "h-full" : viewportHeightWithoutMiniHeader()

    return (
        <>
            {isLoading
                ?
                <div className={`-mt-20 flex w-full justify-center ${heightClass}`}>
                    <LoadingIcon />
                </div>
                :
                error
                    ?
                    <div className={`mt-12 flex w-full justify-center ${heightClass}`}>
                        <h2 className="text-center text-xl text-primaryText">Une erreur est survenue, veuillez réessayer.</h2>
                    </div>
                    :
                    !doesExist
                        ?
                        <div className={`mt-12 flex w-full justify-center ${heightClass}`}>
                            <h2 className="text-center text-xl text-primaryText">Erreur 404: La page demandée n'existe pas.</h2>
                        </div>
                        :
                        <div className={`flex w-full ${heightClass} flex-col items-center`}>
                            {children}
                        </div>

            }
        </>
    )
}
